import { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link} from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import { getShippedOrders, getSalesOrderInstance, updatePostInfo } from '../api/sales';
import { useParams } from "react-router-dom";
import { Info } from 'lucide-react';
import { SidebarProvider } from "../components/SidebarContext";
import InfoMark from '../components/InfoMark';
import ContactFormModal from '../components/ContactFormModal';
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import SidebarToggle from '../components/SidebarToggle';
import Sidebar from '../components/Sidebar';
import jalaliday from "jalaliday";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import "dayjs/locale/fa";
import "../css/OrderMgmt.css";

const OrderReview = () => {
  const [orders, setOrders] = useState([]);
  const [itemSeller, setItemSeller] = useState("");
  const [itemId, setItemId] = useState("");  
  const [error, setError] = useState(null);
  const [consoleError, setConsoleError] = useState("");
  const [pos, setPos] = useState("");
  const [updatedPos, setUpdatedPos] = useState("");
  const [ItemId, setItemID] = useState();
  const [orderItemId, setOrderItemId] = useState();
  const [isInfoModal, setInfoModal] = useState(false);
  const [InfoP, setInfoP] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isContModalOpen, setIsContModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("open"); 
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  const { user, isAuthenticated, loading} = useAuth();
  const navigate = useNavigate();
  const location = useLocation();


  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate(`/${lang}/login`, { state: { from: location }, replace: true });
      }
    }
  }, [user, isAuthenticated, loading, navigate, location]);


  useEffect(() => {
    fetch("/data/InfoNote.json")
      .then((res) => res.json())
      .then((data) => setInfoP(data.SalesManagement))
      .catch((err) => setConsoleError("Error loading content:", err));
  }, []);  
  
  
  const fetchPostInfo = async (OrderId) => {
    try {
      const res = await getSalesOrderInstance(OrderId);
      setPos(res.data);
      setUpdatedPos(res.data);
      setOrderItemId(res.data.id);
    } catch (error) {
      setConsoleError("Error loading user information:", error);
    } 
  };
  
  const fetchOrders = async () => {
    try {
      const res = await getShippedOrders();
      setOrders(res.data.results);
    } catch (error) {
      setConsoleError("Error loading user information:", error);
    } 
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handlePostUpdate = async () => {
    try {
      const UpdatePayload = {
        tracking_number:updatedPos.tracking_number,
        shipping_carrier:updatedPos.shipping_carrier,
        arrival_date:updatedPos.arrival_date,
      };

      await updatePostInfo(ItemId, UpdatePayload);
      fetchOrders();

      // Reset states
      setError("");
      alert(setlang==="en"?"Delivery information updated successfully.":"مشخصات پستی با موفقیت به‌روزرسانی شد");

    } catch (err) {
      setError(setlang==="en"?"Failed to update delivery information. Please login again":"در به‌روزرسانی مشخصات پستی مشکلی رخ داد، لطفا دوباره وارد شو");
    }
  };

  // Update temporary modal form data
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedPos((prev) => ({ ...prev, [name]: value }));
  };

  // Submit: apply changes and close
  const handleSavePost = (e) => {
    e.preventDefault();
    setPos(updatedPos);
    handlePostUpdate(ItemId);
    closeModal();
  };

  // Cancel: discard changes and close
  const handleCancel = () => {
    setPos(pos); 
    closeModal();
  };
  
  // Utilities
  const handleContact = (seller, prod) => {
    setItemSeller(seller);
    setItemId(prod);
    setIsContModalOpen(true);
  };

  const openModal = (itemId) => {
    setItemID(itemId);
    fetchPostInfo(itemId)
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsContModalOpen(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };


  // Transation
  dayjs.extend(utc);
  dayjs.extend(jalaliday);

  const toPersiDigits = (str) => 
    str
    .replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d])
    .replace(/\./g, '/');

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])


  if (loading) return <Loading />;  
  if (!isAuthenticated) return <p>{setlang==="en"?"You must be logged in to review orders.":"لطفا ابتدا وارد حساب کاربری شو"}</p>;
  
  return (
    <>
      <NavbarLog />
      <SidebarProvider>
      <SidebarToggle />

      <Info size={25} className={setlang==="en"?"InfoMark-en":"InfoMark-fa"} onMouseEnter={()=>setInfoModal(true)} onMouseLeave={()=>setInfoModal(false)}/>
      {isInfoModal && <InfoMark info={setlang==="en"?InfoP.en:InfoP.fa} setlang={setlang}/>}
      <div className={setlang==="en"?"order-page-en":"order-page-fa"}>
        
        {setlang==="en" && 
          <Sidebar />
        }

        <div className='order-list'>
          <h2>{setlang==="en"?"My Sales Orders":"سفارش‌های فروش"}</h2>
          <div className={setlang==="en"?"order-tabs-container":"order-tabs-container-fa"}>
            <Link to={`/${setlang}/review/my-sales`}>
              <button
                onClick={() => setActiveTab("open")}
                >
                {setlang === "en" ? "To be shipped" : "در انتظار ارسال"}
              </button>
            </Link>
            <Link to={`/${setlang}/review/delivered-sales`}>
              <button
                onClick={() => setActiveTab("past")}
                className={"active"}
                >
                {setlang === "en" ? "Shipped" : "ارسال شده"}
              </button>
            </Link>
          </div>
          {orders.length === 0 ? (
            <p style={{margin:"20px"}}>{setlang==="en"?"No orders have been shipped yet":"شما تا اکنون سفارشی ارسال نکردید"}</p>
          ) : (
            orders.map((order) => (
              <>
                <div key={order.id} className='item-list'>
                  <ul>
                    {order.items.map((item) => (
                      <li key={item.id}>
                        <div className="order-images">
                          {Array.isArray(item.product_images) && item.product_images.length > 0 &&
                            item.product_images.map((img) => (
                              <img
                                key={img.id}
                                src={img.image}
                                alt={item.product_name}
                                className="order-image"
                              />
                            ))
                          }
                          {/* Videos */}
                          {Array.isArray(item.product_videos) && item.product_videos.length > 0 &&
                            item.product_videos.map((vid) => (
                              <video
                                key={vid.id} 
                                src={vid.video}
                                controls
                                className="order-image"
                              />
                            ))
                          }
                        </div>
                        <div className={setlang==="en"?"arrival-note":"arrival-note-fa"}>
                          <div>
                            <p><strong>{item.product_name}</strong></p>
                            <p>{setlang==="en"?"Price: IRT":"قیمت(تومان):"} {setlang==="en"? new Number(item.price).toLocaleString():toPersiDigits(new Number(item.price).toLocaleString())}</p>
                            <p>{setlang==="en"?"Shipped by:":"ارسال از راه: "} {item.shipping_style}</p>
                            
                            {setlang==="en"?
                            <p><strong>Note: </strong> <span className="highlight">deliveries are expected within two weeks after order's date </span></p>
                            :
                            <p><strong>توجه: </strong><span className="highlight">ارسال و دریافت کالا باید تا ۱۰ روز کاری پس از تاریخ سفارش انجام پذیرد </span></p>
                            }

                            {item.arrival_date === null ? null:
                            setlang==="en"?
                              <span><strong>Expected by: </strong>{dayjs.utc(item.arrival_date).calendar("jalali").locale("fa").format("YYYY/MM/DD")}</span>:
                              <span><strong>مهلت دریافت تا تاریخ: </strong>{toPersiDigits(dayjs.utc(item.arrival_date).calendar("jalali").locale("fa").format("YYYY/MM/DD"))}</span>
                            }
                          </div>

                          <div className="order-actions">
                            <button className='btn' onClick={()=>handleContact(item.seller, item.product)}>{setlang === "en" ? "Contact Seller" : "تماس با فروشنده" }</button>
                          </div>

                          {isContModalOpen && (
                            <div onClick={handleOverlayClick} className="modal-overlay" type='submit'> 
                              <div className="c-modal-container" onClick={e => e.stopPropagation()}>
                                <ContactFormModal receiverId={itemSeller} itemId={itemId} setlang={setlang}/>
                              </div>
                            </div>
                          )}
                        </div>
                      </li>
                    ))}
                  </ul>

                  <div className={setlang==="en"?"order-sum":"order-sum-fa"}>
                    {order.order_status==="shipped"? (
                      <strong ><p style={{marginBottom:"15px", color:"red", fontWeight:"650"}}>{setlang==="en"?"Shipped successfully":"با موفقیت ارسال شد"}</p></strong>
                    ):(
                      <strong><p>{setlang==="en"?"Order Status: ":"وضعیت سفارش: "} {order.order_status}</p></strong>
                    )}
                    <p>{setlang==="en"?"Total: IRT":"جمع کل(تومان): "} {setlang==="en"? new Number(order.total_amount).toLocaleString():toPersiDigits(new Number(order.total_amount).toLocaleString())}</p>
                    <p>{setlang==="en"?"Order Number: ":"شماره سفارش: "} {order.order_number}</p>
                    <p>{setlang==="en"?"Placed on: ":"تاریخ سفارش: "} {setlang==="en"? dayjs.utc(order.created_at).calendar("jalali").locale("fa").format("YYYY/MM/DD"):toPersiDigits(dayjs.utc(order.created_at).calendar("jalali").locale("fa").format("YYYY/MM/DD"))}</p>
                  </div>

                  <div className={setlang==="en"?'delivery-info':'delivery-info-fa'}>
                    <h3>{setlang==="en"?"Delivered To":"آدرس پستی"}</h3>
                    <p>{setlang==="en"?"Name: ":"نام گیرنده: "} {order.delivery.last_name}, {order.delivery.first_name} </p>
                    <p>{setlang==="en"?"Address: ":"آدرس: "} {order.delivery.address} </p>
                    <p>{order.delivery.city}, {order.delivery.province}, {order.delivery.country} </p>
                    <p>{setlang==="en"?"Zipcode: ":"کد پستی: "} {order.delivery.zipcode}</p>
                    <p>{setlang==="en"?"Phone No.: ":"موبایل: "} {order.delivery.contact} </p>
                    <p>{setlang==="en"?"E-mail: ":"ایمیل: "} {order.delivery.email} </p>
                    <p style={{marginTop:"20px"}}> {setlang==="en"?"Delivery Status: ":"وضعیت سفارش: "} {order.delivery.status}</p>
                  </div>
                </div>
              </>
            ))
          )}
        </div> 
        {setlang==="fa" && 
          <Sidebar />
        }
      </div>
      </SidebarProvider>
      <Footer />
    </>
  );
};

export default OrderReview;
